<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Swal from '@/utils/ugm-swal';
/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader },
    data() {
        return {
            title: "Cambiar Contraseña",
            items: [
                {
                text: "Configuración",
                href: "/"
                },
                {
                text: "Cambiar Contraseña",
                active: true
                }
            ],
            datos:{
                id:'',
                password:'',
                confirmPassword:'',
                passwordMatch:null,
            }
        };
    },
    computed:{

    },
    methods:{
        checkMatch() {
            if (this.datos.password && this.datos.confirmPassword) {
                this.datos.passwordMatch = this.datos.password === this.datos.confirmPassword;
            } else {
                this.datos.passwordMatch = null; // Estado inicial si alguno está vacío
            }
        },
        msg(tipo,titulo){
            Swal.fire({
                //position: "top-end",
                icon: tipo,
                title: titulo,
                //text: '',
                showConfirmButton: false,
                timer: 5000
            });
        },
        cambiar(){
            this.datos.id=this.user.id;
            axios.post('/api/cambiarcontraseña',this.datos).then(res=>{
                if(res.data.estado && res.data.color=='danger'){
                    //alert(res.data.mensaje);
                    this.msg('error',res.data.mensaje);
                    this.datos.password='';
                    this.datos.confirmPassword='';
                    this.datos.passwordMatch=null;
                    return
                }else{
                    this.msg('success',res.data.mensaje);
                    this.datos.password='';
                    this.datos.confirmPassword='';
                    this.datos.passwordMatch=null;
                }
            });
        },
    },
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <!-- Header UGM -->
                    <div class="card-header py-3 d-flex align-items-center"
                        style="background: linear-gradient(135deg, #252C5F 0%, #61B7E4 100%); border-radius: 4px 4px 0 0;">
                        <i class="bx bx-lock-alt font-size-24 text-white mr-2"></i>
                        <div>
                            <h5 class="text-white mb-0 font-weight-bold">Cambiar Contraseña</h5>
                            <small class="text-white" style="opacity:.8;">Actualiza tu contraseña de acceso</small>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row mt-3">
                            <div class="offset-md-2 col-md-8">
                                <h4 class="card-title mb-4">Cambiar Contraseña</h4>
                                <b-form-group id="example text" label-cols-sm="12" label-cols-lg="3" label="Contraseña Nueva:" label-for="text">
                                    <b-form-input for="text" type="password" value="" v-model="datos.password" @input="checkMatch"></b-form-input>
                                    <p class="text-danger" v-if="datos.password!='' && datos.password.length<7">Debe ser de 8 caracteres o más.</p>
                                </b-form-group>
                                <b-form-group id="example text" label-cols-sm="12" label-cols-lg="3" label="Confirmar Contraseña:" label-for="text">
                                    <b-form-input for="text" type="password" value="" v-model="datos.confirmPassword" @input="checkMatch"></b-form-input>
                                    <p class="text-danger" v-if="datos.confirmPassword!='' && !datos.passwordMatch">La contraseña no es igual.</p>
                                </b-form-group>
                                <div class="text-right">
                                    <b-button variant="primary" @click="cambiar" v-if="datos.passwordMatch">Cambiar</b-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>